import { getAllUsers } from './authActions';
import BrowseHistory from './BrowseHistory';

// Firebase
import { db, auth, storage } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, serverTimestamp, orderBy, increment, startAfter, limit, onSnapshot } from 'firebase/firestore';

import { 
    SET_PAGE, 
    SET_NAV1, 
    REMOVE_NAV1, 
    SET_NAV2, 
    REMOVE_NAV2, 
    SET_NAV3, 
    REMOVE_NAV3, 
    SET_MAIN_NAV,
    TOGGLE_ITEM_MODAL,
    TOGGLE_COLLECTION_MODAL,
    TOGGLE_LOCATION_MODAL,
    REMOVE_ITEM_MODAL,
    REMOVE_COLLECTION_MODAL,
    REMOVE_LOCATION_MODAL,
    TOGGLE_SIDE_NAV,
    TOGGLE_USER_MODAL,
    TOGGLE_PROFILE_MODAL,
    TOGGLE_CREATE_GROUP_MODAL,
    TOGGLE_CREATE_MATCH_MODAL,
    TOGGLE_AUTH_MODAL,
    TOGGLE_PRIVACY_MODAL,
    TOGGLE_MESSAGE_MODAL,
    SET_AUTH_MODAL,
    SET_PRIVACY_MODAL,
    TOGGLE_VERIFY_MODAL,
    TOGGLE_VERIFY_SCHOOL_MODAL,
    SET_PROFILE_MODAL,
    TOGGLE_POST_MODAL,
    TOGGLE_SHARE_MODAL,
    SET_POST_MODAL,
    TOGGLE_COMMENT_MODAL,
    SET_COMMENT_MODAL,
    SET_SCROLL_TO_TOP,
    // Marketplace
    SET_IS_MARKETPLACE,
    // Driver Portal
    TOGGLE_QUIT_DELIV_MODAL,
    TOGGLE_START_DELIV_MODAL,
    TOGGLE_CONFIRM_PICKUP_MODAL,
    TOGGLE_CUSTOMER_CODE_MODAL,
    // CUSTOM URL LOGIC
    GET_WEBSITE,
    CLEAR_WEBSITE,
    SET_SELECTED_GROUP,
    GET_GROUP,
    // Security Logic
    SET_COUNTRY_CODE,
    SET_CONTINENT_NAME,
    SET_FIREWALL
} from './types';

// Reference to collections in Firestore
const postsCollectionRef = collection(db, "posts");
const groupsCollectionRef = collection(db, "campuses");


export const scrollToTop = (scrollingElementRef) => {
    if (scrollingElementRef.current) {
        scrollingElementRef.current.scrollTop = 0;
    }
}

export const set_scroll_to_top = (value) => dispatch => {
    dispatch({
        type: SET_SCROLL_TO_TOP,
        payload: value
    });
}

export const goBack = () => {

    const url_SkipList = [ // Do not visit these urls when going back
        '/add-code',
        '/select-city',
        '/login',
        '/user_registration',
        '/user_registration?goBack=cart',
        '/register',
        '/forgotpassword',
        '/verify',
        '/addresses',
        '/contact-phone',
        '/logout',
        '/login/sent',
        '/settings/refunds',
        '/profile/edit',
        '/settings/howitworks',
        '/settings/account/screen_name',
        '/settings/account/password',
        '/settings/account/phone',
        '/settings/account/gender',
        '/settings/account/birth_date',
        '/settings/payments',
        '/settings/account',
        '/settings/howitworks',
        '/settings/help',
        '/settings/feedback',
        '/settings/terms',
        '/settings/privacy',
        '/settings/cookies',
        '/settings/account/verify_school_email',
        '/create/post'
    ]; 

    const settings_account_pages = [ // go back to the main account settings page from any of these urls
        '/settings/account/screen_name',
        '/settings/account/password',
        '/settings/account/email',
        '/settings/account/verify_email',
        '/settings/account/phone',
        '/settings/account/gender',
        '/settings/account/birth_date',
        '/settings/account/school_email',
        '/settings/account/verify_school_email'
        
    ]; 

    let browseHistory;

    if(localStorage.recent_history) {

        browseHistory = new BrowseHistory(JSON.parse(localStorage.recent_history));

        const url_filter = (window.location.href);
        const url = new URL(url_filter);

        let currentURL = url.pathname;
        if(url.search) {
            currentURL += url.search;
        }
        let previousURL;

        // Keep popping until we find a URL that is not equal to the current URL
        while ( !browseHistory.isEmpty()) { 
            const topURL = browseHistory.peek();

            // Keep popping until we find url that does not match the comment && chatBox page route
            const isCommentRoute = /^\/create\/comment\/[a-zA-Z0-9]+$/.test(topURL);
            // const isChatBoxPageRoute = /^\/messages\/[a-zA-Z0-9]+$/.test(topURL); // do not add chat page urls
            const isChatBoxPageRoute = false;
            const isProfileRoute = topURL.includes("?show="); // Profile page sub route - don't visit
            
            if (topURL !== currentURL && !url_SkipList.includes( topURL ) && !isCommentRoute && !isChatBoxPageRoute ) {
                break;
            }

            previousURL = browseHistory.pop();

            if (isProfileRoute) {
                previousURL = previousURL.split("?show=")[0];
            }
        }

        if (!browseHistory.isEmpty()) {
            previousURL = browseHistory.pop();
        }

        // Store the current page in local storage as recent_history
        localStorage.setItem("recent_history", JSON.stringify(browseHistory));

        if(settings_account_pages.includes( currentURL ) && currentURL !== '/settings') {
                window.location.href = '/settings/account';
        } else if (previousURL && previousURL !== currentURL && !(previousURL === '/settings/account' && currentURL === '/settings')) { // If we have found a different URL, navigate to it
            // console.log('OPTION 1', previousURL)
            window.location.href = previousURL;
        } else {
            // console.log('OPTION 2', previousURL)
            // If no different URL is found, navigate to home
            window.location.href = '/home';
        }
  
    } else {
        // console.log('OPTION 3')
        window.location.href = '/home';
    }
}


export const add_To_Recent_History = (currentURL) => dispatch => {
    let browseHistory;
    
    if(localStorage.recent_history) {

        browseHistory = new BrowseHistory(JSON.parse(localStorage.recent_history));

        // Delete Recent History if its over 24 hours old
        if (isOver24HoursAgo(browseHistory.createdAt)) {
            localStorage.removeItem("recent_history");

            // Reset Browse History
            browseHistory = new BrowseHistory();
            browseHistory.setTimestamp();
        }
        
    } else {

        browseHistory = new BrowseHistory();
        browseHistory.setTimestamp();
    }

    const url_filter = (window.location.href);
    let url = new URL(url_filter);

    if (url.search) {
        if(currentURL !== '/settings/account/verify_school_email' && currentURL !== '/create/post'){
            currentURL += url.search;
        }
    }

    // Check if the currentURL matches '/create/comment/:id' OR '/messages/:id' and skip adding to history if it does 
    // (don't want to user to be able to goBack to this page)
    const isCommentRoute = /^\/create\/comment\/[a-zA-Z0-9]+$/.test(currentURL);
    // const isChatBoxPageRoute = /^\/messages\/[a-zA-Z0-9]+$/.test(currentURL); // do not add chat page urls
    const isChatBoxPageRoute = false;
    const isProfileRoute = currentURL.includes("?show="); // Profile page sub route - don't add to history

    if (isProfileRoute) {
        currentURL = currentURL.split("?show=")[0];
    }

    if ( !isCommentRoute && !isChatBoxPageRoute ) {
        if(currentURL !== browseHistory.peek()) {
            browseHistory.push(currentURL); // page is a string [ 'Home Page' ] 
        } else if (url.search){ // if the url's are equal than add it to the stack
            browseHistory.push(currentURL+url.search);
        }
    } else {
        console.log('Skipping adding route to history');
    }

    // Store the current page in local storage as recent_history
    localStorage.setItem("recent_history", JSON.stringify(browseHistory));
}

export const setPage = (page) => dispatch => {
    dispatch({
        type: SET_PAGE,
        payload: page
    });
}

export const toggleUserModal = () => dispatch => {
    // dispatch(getAllUsers());

    dispatch({
        type: TOGGLE_USER_MODAL,
    });
}

export const toggleProfileModal = () => dispatch => {
    dispatch({
        type: TOGGLE_PROFILE_MODAL,
    });
}

export const toggleCreateGroupModal = () => dispatch => {
    dispatch({
        type: TOGGLE_CREATE_GROUP_MODAL,
    });
}

export const toggleCreateSportsMatchModal = () => dispatch => {
    dispatch({
        type: TOGGLE_CREATE_MATCH_MODAL,
    });
}

export const togglePostModal = () => dispatch => {
    dispatch({
        type: TOGGLE_POST_MODAL,
    });
}

export const setPostModal = (value) => dispatch => {
    dispatch({
        type: SET_POST_MODAL,
        payload: value
    });
}

export const toggleCommentModal = () => dispatch => {
    dispatch({
        type: TOGGLE_COMMENT_MODAL,
    });
}

export const setCommentModal = (value) => dispatch => {
    dispatch({
        type: SET_COMMENT_MODAL,
        payload: value
    });
}

export const toggleAuthModal = (type) => dispatch => {
    dispatch({
        type: TOGGLE_AUTH_MODAL,
        payload: type
    });
}

export const togglePrivacyModal = (type) => dispatch => {
    dispatch({
        type: TOGGLE_PRIVACY_MODAL,
        payload: type
    });
}

export const toggleMessageModal = (type) => dispatch => {
    dispatch({
        type: TOGGLE_MESSAGE_MODAL,
        payload: type
    });
}

export const setAuthModal = (toggle_state) => dispatch => {
    dispatch({
        type: SET_AUTH_MODAL,
        payload: toggle_state
    });
}

export const setPrivacyModal = (toggle_state) => dispatch => {
    dispatch({
        type: SET_PRIVACY_MODAL,
        payload: toggle_state
    });
}

export const toggleVerifyModal = (type) => dispatch => {
    dispatch({
        type: TOGGLE_VERIFY_MODAL,
        payload: type
    });
}

export const toggleVerifySchoolModal = (type) => dispatch => {
    dispatch({
        type: TOGGLE_VERIFY_SCHOOL_MODAL,
        payload: type
    });
}

export const setProfileModal = (value) => dispatch => {
    dispatch({
        type: SET_PROFILE_MODAL,
        payload: value
    });
}

export const toggleShareModal = () => dispatch => {
    dispatch({
        type: TOGGLE_SHARE_MODAL,
    });
}

export const setNav1 = (nav) => dispatch => {
    dispatch({
        type: SET_NAV1,
        payload: nav
    });
}

export const setNav2 = (nav) => dispatch => {
    dispatch({
        type: SET_NAV2,
        payload: nav
    });
}
export const setNav3 = (nav) => dispatch => {
    dispatch({
        type: SET_NAV3,
        payload: nav
    });
}
export const removeNav1 = () => dispatch => {
    dispatch({
        type: REMOVE_NAV1,
    });
}
export const removeNav2 = () => dispatch => {
    dispatch({
        type: REMOVE_NAV2,
    });
}
export const removeNav3 = () => dispatch => {
    dispatch({
        type: REMOVE_NAV3,
    });
}

// Set Admin Nav
export const setMainNav = (value) => {
    return {
        type: SET_MAIN_NAV,
        payload: value
    }
}

// Toggle Main Side Nav
export const toggleSideNav = () => dispatch => {
    dispatch({
        type: TOGGLE_SIDE_NAV,
    });
}

export const toggleItemModal = () => dispatch => {
    dispatch({
        type: TOGGLE_ITEM_MODAL,
    });
}

export const toggleCollectionModal = () => dispatch => {
    dispatch({
        type: TOGGLE_COLLECTION_MODAL,
    });
}

export const toggleLocationModal = () => dispatch => {
    dispatch({
        type: TOGGLE_LOCATION_MODAL,
    });
}

export const removeItemModal = () => dispatch => {
    dispatch({
        type: REMOVE_ITEM_MODAL,
    });
}

export const removeCollectionModal = () => dispatch => {
    dispatch({
        type: REMOVE_COLLECTION_MODAL,
    });
}

export const removeLocationModal = () => dispatch => {
    dispatch({
        type: REMOVE_LOCATION_MODAL,
    });
}

// --- MARKETPLACE ---
export const setIsMarketplace = (value) => dispatch => {
    dispatch({
        type: SET_IS_MARKETPLACE,
        payload: value
    });
}

// --- DRIVER PORTAL ----

export const toggle_QuitDelivery_Modal = () => dispatch => {
    dispatch({
        type: TOGGLE_QUIT_DELIV_MODAL,
    });
}

export const toggle_StartDelivery_Modal = () => dispatch => {
    dispatch({
        type: TOGGLE_START_DELIV_MODAL,
    });
}

export const toggle_ConfirmPickup_Modal = () => dispatch => {
    dispatch({
        type: TOGGLE_CONFIRM_PICKUP_MODAL,
    });
}

export const toggle_CustomerCode_Modal = () => dispatch => {
    dispatch({
        type: TOGGLE_CUSTOMER_CODE_MODAL,
    });
}

// --- END: DRIVER PORTAL ----

// -- CUSTOM URL LOGIC -- 

export const get_Website_By_Url = (url) => async dispatch => {
    // Dispatch the clearWebsiteData action to reset the custom website state
    dispatch(clearWebsiteData());

    if(url.includes('localhost:3000') || url.includes('buysell.app')) {
        dispatch({
            type: GET_WEBSITE,
            payload: null
        });

        return;
    }

    if(url.includes('xbuysell-dev.web.app')) {
        url = 'https://www.utbuysell.com';
    }
    
    try {
        console.log("GET CUSTOM WEBSITE BY DOMAIN");
        console.log(url);

        // Create a query to fetch documents based on the specified filter
        const q = query (groupsCollectionRef, where("url", "==", url.toLowerCase()))

        // Retrieve the query snapshot containing the documents
        const querySnapshot = await getDocs(q);
        console.log('FETCHED WEBSITE DATA');

  
        // Dispatch the GET_WEBSITE action with the data of the first document in the query snapshot as the payload
        if(querySnapshot?.docs[0]) {
            
            const website_obj = { _id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() }

            dispatch({
                type: GET_WEBSITE,
                payload: website_obj
            });

            // Set selected group as well (so TweetBox is synced to current group / website viewing)
            dispatch({
                type: SET_SELECTED_GROUP,
                payload: website_obj
            });

            // Dispatch an action of type GET_GROUP (so everything is synced to current group / website viewing)
            dispatch({
                type: GET_GROUP,
                payload: website_obj
            });
        } else {
            dispatch({
                type: GET_WEBSITE,
                payload: null
            });
        }
    } catch (err) {

        console.log('Failed to load custom website data')
        console.log(err);

        dispatch({
            type: GET_WEBSITE,
            payload: null
        });
    }
}

// Remove current profile info from state
export const clearWebsiteData = () => dispatch => {
    dispatch({
        type: CLEAR_WEBSITE
    });

}

// -- Site Security Function ---

export const set_country_code = (country_code) => dispatch => {
    dispatch({
        type: SET_COUNTRY_CODE,
        payload: country_code
    });
}

export const set_continent_name = (continent_name) => dispatch => {
    dispatch({
        type: SET_CONTINENT_NAME,
        payload: continent_name
    });
}

export const set_isVPN = (timezones_differ) => dispatch => {
    dispatch({
        type: SET_FIREWALL,
        payload: timezones_differ
    });
}

// -- END: Site Security Function ---

// -- Utility Functions --

export const  isOver24HoursAgo = (createdAt) => {
    const currentTime = Date.now();
    const timeDifference = currentTime - createdAt;
    const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert milliseconds to hours
    return hoursDifference > 24;
}
